import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { ButtonComponent, TabsComponent } from "./SubComponents";
import { detailTabsOptions } from "./Constants";
import { useHistory, useParams } from "react-router";
import ExportButtons from "./exportButton";
import editFaultIcon from "../../img/af-icon.png";
import { getFaultHistory } from "../../actions/detailStationFault";
import { Loader } from "../Utils/Loader";
import { services } from "../../api";
import { RenderFaultHistory } from "./RenderFaultHistory";
import { setLoader } from "../../actions/Header";
import moment from "moment";

const FaultDetails = (props) => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [faultDetail, setfaultDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [isCustomerDisable, setCustomerDisable] = useState(true);
  const [customerUpdate, setCustomerUpdate] = useState("");
  const [error, setError] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const [selectedDetailTab, setDetailTab] = useState({
    id: 101,
    title: "Fault Details",
    icon: "cfacility-fault-icon",
  });
  const [imgUrl, setImgUrl] = useState("");
  const [faultHistory, setFaultHistory] = useState([]);
  const date =
    faultDetail &&
    faultDetail["Date & Time"] &&
    faultDetail["Date & Time"].split(".")[0];
  const optedIn =
    faultDetail && faultDetail["Opted In"] === 1 ? "true" : "false";

  const getFaultHistoryData = useSelector(
    (state) => state.DetailStationFaults.faultHistory
  );

  const profile = useSelector((state) => state.profileReducer);
  const userData = useSelector((state) => state.usersReducers);
  let tab =
    params.type === "customertrainfault"
      ? "ctf"
      : params.type === "suggestions"
      ? "cs"
      : "cff";

  useEffect(async () => {
    // setLoading(true);
    let faultDetail = history.location.details;

    if (faultDetail) {
      let historyParams = {
        tab:
          params.type === "customerfacilityfault"
            ? "cff"
            : params.type === "customertrainfault"
            ? "ctf"
            : "cs",
        id: params.id,
      };
      setfaultDetail(faultDetail);

      if (historyParams.tab != "cs" && faultDetail["File ID"]) {
        let tabName =
          params.type === "customerfacilityfault"
            ? "Customer Station Faults"
            : params.type === "customertrainfault"
            ? "Customer Train Faults"
            : "";
        let filePath = `${tabName}/${faultDetail.id}/file_${faultDetail["File ID"]}/`;
        let imageUrl = await services.getDetailImage(filePath);
        setImgUrl(imageUrl);
      }
      setCustomerUpdate(faultDetail["Update Customer"]);
      dispatch(getFaultHistory(historyParams));
    } else {
      onClickHandler("back");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    setFaultHistory(getFaultHistoryData);
  }, [getFaultHistoryData]);

  const tabsHandler = (tab) => {
    setDetailTab(tab);
  };

  let dateSplit =
    faultDetail && faultDetail["Date & Time"]
      ? moment(faultDetail["Date & Time"]).format("YYYY-MM-DD").split("-")
      : [];
  const fileId = faultDetail && faultDetail["File ID"];

  let d1 = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]);

  let dateDiff = Math.round(
    (new Date().getTime() - d1.getTime()) / (1000 * 60 * 60 * 24)
  );

  let isArchive = faultDetail && faultDetail["Is Archive"];

  const onClickHandler = async (btnType = "") => {
    if (btnType == "back") {
      if (history)
        history.push({
          pathname: `/FaultReporter/admin/${params.type}`,
          state: {
            reportId: params.reportId,
            isArchive: isArchive ? isArchive : 0,
          },
        });
    } else if (btnType == "edit") {
      if (params.type === "customerfacilityfault") {
        history.push({
          pathname: `/FaultReporter/admin/customerfacilityfault/${params.id}/edit/fault/${params.reportId}`,
          details: { faultDetail: faultDetail, imgUrl: imgUrl },
        });
      } else if (params.type === "customertrainfault") {
        history.push({
          pathname: `/FaultReporter/admin/customertrainfault/${params.id}/edit/fault/${params.reportId}`,
          details: { faultDetail: faultDetail, imgUrl: imgUrl },
        });
      }
    } else if (btnType === "archive") {
      let obj = {
        tab: tab,
        ID: params.id,
        archive: isArchive == 1 ? "0" : isArchive == 0 ? "1" : "",
      };
      let res = await services.ServiceMethod("archive", "put", {
        payload: obj,
      });
      if (res) {
        history.push(`/FaultReporter/admin/${params.type}`);
      }
    } else if (btnType == "updateCustomer") {
      setCustomerDisable(false);
    }
  };

  const onSaveCustomerUpdate = async (btn = "save") => {
    if (btn == "cancel") {
      setCustomerDisable(true);
      setCustomerUpdate(faultDetail["Update Customer"]);
      return;
    }
    if (customerUpdate.length < 3) {
      setError("Please enter customer update");
      return;
    }
    let formData = new FormData();
    let suggestion_date = moment(date).format("DD-MM-YYYY HH:mm");
    formData.append("values", customerUpdate);
    formData.append("is_opted_for_update", faultDetail["Opted In"]);
    formData.append("email", faultDetail.Email || "");
    formData.append("mobile_number", faultDetail["Mobile Number"] || "");
    formData.append("suggestion_date", suggestion_date || "");

    dispatch(setLoader(true));
    let success = await services.updateCustomer(
      `editfault?tab=${tab}&ID=${params.id}&username=${profile.fullname}`,
      "post",
      formData
    );
    if (success) {
      history.push(`/FaultReporter/admin/${params.type}`);
    }
  };
  const {
    Embarked,
    Disembarked,
    Station,
    Details,
    Reported,
    Suggestion,
    Status,
  } = faultDetail;
  const { type } = params;

  let archiveBtn = "Archive Fault";

  if (isArchive) {
    if (type == "suggestions") {
      archiveBtn = "Live Suggestion";
    } else {
      archiveBtn = "Live Fault";
    }
  } else {
    if (type == "suggestions") {
      archiveBtn = "Archive Suggestion";
    }
  }

  if (loading) {
    return <Loader />;
  }
  if (
    userData.isAuthorized &&
    (userData.roleID === 3 || userData.roleID === 4 || userData.roleID === 5)
  ) {
    return (
      <div className="details-section">
        <TabsComponent
          type={type}
          tabsOptions={detailTabsOptions}
          selectedTab={selectedDetailTab}
          tabsHandler={tabsHandler}
        />
        {selectedDetailTab && selectedDetailTab.id === 101 ? (
          <>
            <div className="detail-headline">
              <h6>Customer Station Fault Details</h6>
              <div className="details-export">
                <ExportButtons isArchive={faultDetail["Is Archive"]} />{" "}
              </div>
              <div className="detail-button">
                <ButtonComponent
                  title="Back"
                  icon="zmdi zmdi-arrow-left"
                  onClickHandler={() => onClickHandler("back")}
                />
                {type !== "suggestions" &&
                  faultDetail["Status"] !== "Complete" && (
                    <button
                      className="back-btn comman-btn"
                      onClick={() => onClickHandler("edit")}
                    >
                      <span>
                        <img src={editFaultIcon} alt="edit" />
                      </span>
                      Edit Fault
                    </button>
                  )}
                {(Status === "Complete" || type == "suggestions") && (
                  <ButtonComponent
                    title={archiveBtn}
                    onClickHandler={() => onClickHandler("archive")}
                  />
                )}
              </div>
            </div>
            <div className="details-content">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                  <table className="table">
                    <tbody>
                      {type != "suggestions" && (
                        <tr>
                          <td className="detail-label">Reference id</td>
                          <td>
                            {!_.isEmpty(faultDetail) && faultDetail.Ref_Id}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="detail-label">Date and time</td>

                        <td>{moment(date).format("DD-MM-YYYY HH:mm")}</td>
                      </tr>
                      {Embarked && (
                        <tr>
                          <td className="detail-label">Embarked</td>
                          <td>{Embarked || ""}</td>
                        </tr>
                      )}
                      {Station && (
                        <tr>
                          <td className="detail-label">Station</td>
                          <td>{Station}</td>
                        </tr>
                      )}
                      {Details && (
                        <tr>
                          <td className="detail-label">Details of fault</td>
                          <td className="detail-area">{Details}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td className="detail-label">Customer name</td>
                        <td>{faultDetail.Name}</td>
                      </tr>
                      {Disembarked && (
                        <tr>
                          <td className="detail-label">Disembarked</td>
                          <td>{Disembarked}</td>
                        </tr>
                      )}
                      <tr>
                        <td className="detail-label">Email address</td>
                        <td>{faultDetail.Email}</td>
                      </tr>
                      <tr>
                        <td className="detail-label">Mobile number</td>
                        <td>{faultDetail["Mobile Number"]}</td>
                      </tr>
                      {type != "suggestions" &&
                        faultDetail["Status"] == "Complete" && (
                          <tr>
                            <td className="detail-label">Comments</td>
                            <td className="detail-area">
                              {faultDetail["comments"]}
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                  <table className="table">
                    <tbody>
                      {type != "suggestions" && (
                        <tr>
                          <td className="detail-label">Reported to staff</td>
                          <td>{Reported ? "true" : "false"}</td>
                        </tr>
                      )}
                      <tr>
                        <td className="detail-label">Opted in for updates</td>
                        <td>{optedIn || ""}</td>
                      </tr>
                      {Status && (
                        <tr>
                          <td className="detail-label">Status</td>
                          <td>{Status}</td>
                        </tr>
                      )}
                      {type != "suggestions" && (
                        <>
                          <tr>
                            <td className="detail-label">Image</td>
                            <td className="detail-area">
                              {fileId && imgUrl ? (
                                <img
                                  onClick={() => setIsImageModalOpen(true)}
                                  className="img-thumbnail img img-preview"
                                  src={imgUrl}
                                  title="faultImg"
                                  alt="fault"
                                />
                              ) : (
                                "No image uploaded."
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 sugg-table1">
                  {Suggestion && (
                    <table>
                      <tbody>
                        <tr>
                          <td className="detail-label">Suggestion</td>
                        </tr>
                        <tr>
                          <td>{Suggestion}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}

                  {type == "suggestions" && (
                    <>
                      <textarea
                        className={isCustomerDisable ? "input-disable" : ""}
                        disabled={isCustomerDisable}
                        rows="4"
                        name="description"
                        onChange={(e) => setCustomerUpdate(e.target.value)}
                        value={customerUpdate}
                        placeholder="Please Enter Customer Update"
                      />
                      {error.length ? (
                        <span className="error">{error}</span>
                      ) : (
                        <React.Fragment />
                      )}
                    </>
                  )}
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 sugg-btn">
                  {Suggestion && dateDiff < 30 && (
                    <>
                      {isCustomerDisable ? (
                        <ButtonComponent
                          title="Update Customer"
                          onClickHandler={() =>
                            onClickHandler("updateCustomer")
                          }
                        />
                      ) : (
                        <>
                          <ButtonComponent
                            title="Save"
                            onClickHandler={() => onSaveCustomerUpdate("save")}
                          />
                          <ButtonComponent
                            title="Cancel"
                            onClickHandler={() =>
                              onSaveCustomerUpdate("cancel")
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <RenderFaultHistory faultHistory={faultHistory} />
        )}
        {isImageModalOpen && (
          <div
            className="modal d-block modal-background"
            id="imageModal"
            tabIndex="-1"
            aria-labelledby="imageModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setIsImageModalOpen(false)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <h4 className="modal-title" id="myModalLabel">
                    Fault image
                  </h4>
                </div>
                <div className="modal-body">
                  <img
                    alt="The fault submitted is not an image"
                    style={{ height: "100%", width: "100%" }}
                    src={imgUrl}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return <div className="not-page">User Not Authorized</div>;
};

export default FaultDetails;
